<template>
  <div id="app">
    <router-view></router-view>
     <el-dialog title="文件预览" class="claimBox" :visible.sync="pdfLayer" center width="1000px" :append-to-body="true" >
      <div class="yulan" style="display: flex;align-items: center;justify-content: center;">
        <iframe v-if="pdfPreviewUrl.slice(-3) === 'pdf'||pdfPreviewUrl.slice(-3) === 'PDF'" :src="pdfPreviewUrl" frameborder="0" style="width: 100vw;height: 70vh;"></iframe>
        <img v-if="pdfPreviewUrl.slice(-1) === 'g'" :src="pdfPreviewUrl" alt="" width="80%" height="80%">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import $ from 'jquery';
export default {
  name: 'App',
  data() {
    return {
      pdfPreviewUrl: "",
      showpdf: true,
      pdfLayer: false,
    }
  },
  mounted() {
  },
  methods:{
    // 下载用API
    download () {
     //下载文件
      let formName = ''
      let text = this.getUrlType(this.pdfUrl)
      let type = this.getApplicationType(text)
      formName = this.pdfName + '.' +text
      var xhr = new XMLHttpRequest();
      xhr.open("get", this.BASEURL+`/raise-common/download/downloadFile?name=文件下载&url=${this.pdfUrl}`, true); // 也可以使用POST方式，根据接口
      xhr.withCredentials = true
      xhr.responseType = "blob"; // 返回类型blob
      xhr.onload = ()=>{
          var blob = new Blob([xhr.response],{type}),
          Temp = document.createElement("a")
          Temp.href = window.URL.createObjectURL(blob);
          // console.log(blob);
          Temp.download = formName//设置下载名
          $('body').append(Temp);
          Temp.click()
      }
      xhr.send()
    },
    showPdf(url, name) {
      if (!url) {
        this.alertMsg("暂无文件！");
        return;
      }
      this.pdfPreviewUrl =url;
      this.pdfUrl = url
      this.pdfName = name
      console.log('location.origin', location.origin)

      console.log('this.pdfPreviewUrl---------01', this.pdfPreviewUrl)
      this.pdfLayer = true;
      this.showpdf = true;
    },
  }
}
</script>

<style lang="scss">
@import "./assets/style/comm.scss";
body{
  position: relative;
  top: -60px;
  width: 100%;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
/* CSS样式 */
@media screen and (max-width: 750px) {
  .phone-span.hidden-xs {
    display: none !important; /* 在屏幕宽度小于或等于750px时隐藏该元素 */
  }
}
.pull_right {
  display: inline-block;
  float: right !important;
}
a {
    color: #428bca;
    text-decoration: none;
}
@media screen and (min-width: 1200px){
  .container {
      // min-width: 1200px;
      max-width: 1170px;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
  }
}
</style>
